import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetOverallOccupancyForecastResponseDtoSchema = z.object({
  actuals: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
  forecast: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
});

const _GetOverallOccupancyForecastRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
});

export type GetOverallOccupancyForecastResponseDto = z.infer<
  typeof GetOverallOccupancyForecastResponseDtoSchema
>;
export type GetOverallOccupancyForecastRequestDto = z.infer<
  typeof _GetOverallOccupancyForecastRequestDtoSchema
>;

export const getOverallOccupancyForecast = (
  params: GetOverallOccupancyForecastRequestDto,
  config?: AxiosRequestConfig<GetOverallOccupancyForecastRequestDto>
) => {
  return api
    .get('facilities/occupancy-forecast', { params, ...config })
    .then(responseContract(GetOverallOccupancyForecastResponseDtoSchema));
};
